import React from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import Config from '../../util/config';
import DayComponent from './Day';
import { Day, getDays, getStartDate, getEndDate, loopDates } from '../../util/date';
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)

interface CalendarProps {
    start: string;
    selectable: string[];
    selected: string;
    onDaySelect: (day: dayjs.Dayjs) => void;
    nights: number;
    endSelected: string;
}

const Calendar = (props: CalendarProps) => {
    const month = dayjs(props.start + '-01', 'YYYY-MM-DD');
    const start = getStartDate(month, Config.get('startingDay', 'Mon'));
    const end =
      Config.get("hideDatesNotInMonth", "no") === "yes"
        ? getEndDate(month, Config.get("startingDay", "Mon")).add(1, "week")
        : getEndDate(month, Config.get("startingDay", "Mon"));
    const selected = dayjs(props.selected, 'YYYY-MM-DD');
    let endSelected: any = false

    const monthNumber = month.format(Config.get('DateFormat', 'M'))

    if (props.endSelected) {
        endSelected = dayjs(props.endSelected, 'YYYY-MM-DD')
    } else if(selected && props.nights) {
        endSelected = selected.clone().add(props.nights, 'days')
    }

    const datesAreEqual = (day: dayjs.Dayjs, secondDay: dayjs.Dayjs) => {
        return day.format('YYYY-MM-DD') == secondDay.format('YYYY-MM-DD')
    }

    const applyClasses = (day: dayjs.Dayjs | null): string[] => {
        if (!day) {
          return [];
        }

        const classes = ['calendar__day', 'calendar__day--selectable', 'calendar__day--not-booked']
        const selectedClass = "calendar__day--selected";
        const rangeSelectClass = "calendar__day--rangeSelect";
        const selectedEndsClass = "calendar__day--selectedEnds";
        const isValidSelected = selected.isValid();
        const isStart = datesAreEqual(day, selected)

        if(day.isBefore(dayjs().subtract(1, 'day'))){
            classes.push('calendar__day--booked');
            return classes;
        }

        if (!isValidSelected) {
          return classes;
        }

        if(isStart) {
            classes.push('calendar__day--selectedStarts');
            classes.push(selectedClass);
        }

        if(!endSelected || !endSelected.isValid()) {
            return classes;
        }

        const isEnd = datesAreEqual(day, endSelected);
        const isInRange = day.isBetween(selected, endSelected, null, '[]');
        const isRangeSelectDay = isInRange && !isStart && !isEnd;

        if (isInRange) {
            classes.push(selectedClass);
        }

        if (isRangeSelectDay) {
            classes.push(rangeSelectClass);
        } else if (isStart || isEnd) {
            classes.push(selectedEndsClass);
        }

        return classes;
    }

    const days: JSX.Element[] = [];
    loopDates(start, end, 'day', (day: dayjs.Dayjs) => {
        const classes: string[] = applyClasses(day)
        let selectable = true;

        if(classes.includes("calendar__day--booked")){
            selectable = false
        }

            days.push(
                <DayComponent
                    key={day.format('YYYY-MM-DD')}
                    className={classes.join(' ')}
                    clickable={selectable}
                    classNameDay="calendar__day-number"
                    onClick={props.onDaySelect}
                    month={month}
                    day={day}
                />
            );
    });

    const daysWithRows: JSX.Element[] = [];
    let index: number = 0;
    while (days.length) {
        const row = days.splice(0, 7);
        daysWithRows.push(
            <div key={index} className="calendar__row">
                {row}
            </div>
        );
        index += 1;
    }

    const headers = getDays(Config.get('startingDay', 'Mon')).map((day: Day): JSX.Element => {
        return <span key={day.short} className="calendar__header">{day.short}</span>;
    });
    return <div className="calendar">
        <div className="calendar__row calendar__row--headers">
            {headers}
        </div>
        {daysWithRows}
    </div>
}

export default Calendar;


